import { render, staticRenderFns } from "./client-profile-name-label.vue?vue&type=template&id=6fd87a25"
import script from "./client-profile-name-label.vue?vue&type=script&lang=ts"
export * from "./client-profile-name-label.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports